const formatMessageDate = (timestamp) => {
  const messageDate = new Date(timestamp);
  const now = new Date();
  
  // Reset hours to compare just the dates
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const yesterday = new Date(today);
  yesterday.setDate(yesterday.getDate() - 1);
  
  const messageDay = new Date(messageDate.getFullYear(), messageDate.getMonth(), messageDate.getDate());
  
  // Check if it's today
  if (messageDay.getTime() === today.getTime()) {
    return 'Today';
  }
  
  // Check if it's yesterday
  if (messageDay.getTime() === yesterday.getTime()) {
    return 'Yesterday';
  }
  
  // Check if it's within the last week
  const oneWeekAgo = new Date(today);
  oneWeekAgo.setDate(oneWeekAgo.getDate() - 7);
  
  if (messageDay >= oneWeekAgo) {
    return getDayName(messageDate);
  }
  
  // If it's this year, show date without year
  if (messageDate.getFullYear() === now.getFullYear()) {
    return messageDate.toLocaleDateString('en-US', { 
      month: 'short', 
      day: 'numeric' 
    });
  }
  
  // If it's older than this year, show full date
  return messageDate.toLocaleDateString('en-US', { 
    month: 'short', 
    day: 'numeric',
    year: 'numeric'
  });
};

const formatTime = (date) => {
  return date.toLocaleTimeString('en-US', { 
    hour: 'numeric', 
    minute: '2-digit',
    hour12: true 
  });
};

const getDayName = (date) => {
  return date.toLocaleDateString('en-US', { weekday: 'long' });
};

export { formatMessageDate, formatTime }; 